import List5SAuditMobile from "./List5SAudit.mobile";

function List5SAuditMain() {
  return <List5SAuditMobile />;
}

export default List5SAuditMain;
